module.exports = __webpack_public_path__ + "img/properties.667ab9e2.svg";